<template>
<div id="messages">
	<header>
		<a href="#" @click.prevent="goBack" class="back"></a>
		<h1>Neue Nachricht</h1>
	</header>
	<user-select v-model="partner" placeholder="Nachricht senden an" @select="$refs.message.focus()" type="friends" />
	<ul></ul>
	<form id="send-message" @submit.prevent="send()">
		<input type="text" v-model="message" ref="message">
		<input type="submit" value="Senden">
	</form>
</div>
</template>

<script>
import base from 'base.vue'
import userSelect from 'components/user-select.vue'

export default {
	mixins: [ base ],
	components: { userSelect },
	data () {
		return {
			partner: null,
			message: ''
		}
	},
	methods: {
		send () {
			const that = this

			this.$api.post(`conversations/${this.partner.id}/send`, {
				message: this.message
			})
			.then(response => {
				that.$router.replace(`/conversations/${this.partner.id}`)
			})
		}
	}
}
</script>


// WEBPACK FOOTER //
// conversation-new.vue?bb766d02